<template>
  <div class="scroll-wrap">
    <div class="scroll-content">
      <!-- 头图区域 -->
      <div class="header" :style="{backgroundImage: `url(${headerImage})`}">
        <!-- 活动规则按钮 -->
        <div class="ruleBtn" @click="openModal('modalRuleShow')"></div>
      </div>
      <!-- 填写信息区域 -->
      <div class="infoBox"
      :style="{backgroundImage: `url(${infoImage})`}">
        <GetInfo
        :getCouponFlag="getCouponFlag"
        :share_channel="share_channel"
        :startTime="startTime"
        @jumpUrl="jumpUrl"
        @Refresh="Refresh"
        ></GetInfo>
      </div>
      <!-- 规则底图区域 -->
      <div class="rule" >
        <img alt="" :src="ruleImage">
      </div>
    </div>
  </div>
</template>

<script>
import { log } from '@ali/amap-lib';
import CONFIG_ACT from '../../../config/config.act';
import GetInfo from '../../../common/components/GetInfo.vue';

export default {
  name: 'app',
  components: {
    GetInfo, // 填写信息模块
  },
  data() {
    return {
      titleData: { title: '首页', color: '#616161', backgroundColor: '#ffffff' },
    };
  },
  props: {
    allConf: {
      default: () => ({})
    },
    getCouponFlag: {
      default: false,
      type: Boolean
    },
    share_channel: {
      type: String,
      default: '',
    },
    startTime: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    // 刷新首页接口
    Refresh() {
      this.$emit('Refresh');
    },
    // 弹窗内调用呼端逻辑
    jumpUrl(url) {
      this.$emit('jumpUrl', url);
    },
    openModal(modalName) {
      this.$emit('modalOpen', modalName);
      log.log('activity_rule', {
        islogin: '',
        active_state: '',
        activity_id: CONFIG_ACT.actId,
        uid: ''
      });
    },
  },

  computed: {
    immersiveHeight() {
      return this.$root.immersiveHeight;
    },
    headerImage() {
      return this.allConf && this.allConf.invited_icon;
    },
    infoImage() {
      return (this.allConf && this.allConf.out_background_icon);
    },
    ruleImage() {
      return this.allConf && this.allConf.invited_question;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../css/index";
@import "../../../common/css/common-mixin";
.scroll-wrap{
  width: 100%;
  .scroll-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .header{
      width: 100%;
      height: rpx(549);
      background-position: center top;
      background-size: 100% 100%;
      position: relative;
      .ruleBtn{
        position: absolute;
        top:rpx(36);
        right: 0;
        width: rpx(145);
        height: rpx(54);
        background: url('../../../assets/index/rule-btn.png') center top/ contain no-repeat;
      }
      .normalBtn{
        position: absolute;
        top: rpx(825);
        transform: translateX(-50%);
        left: 50%;
        width: 100%;
        height: rpx(186);

      }
      .redcContent{
        .redcContentTime{
          min-width: rpx(330);
          max-width: rpx(500);
          min-height: rpx(58);
          font-size: rpx(25);
          font-weight: bold;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: rpx(156);
          background: #ff1b05;
          color: #fff;
          border-radius: rpx(15);
          padding: 0 rpx(20);
          display: flex;
          align-items: center;
          text-align: center;
          box-shadow: 0 rpx(2) 0 0 #e10000 inset;
        }
        .phoneHeight{
          width: rpx(500);
        }
        .login-get-btn{
          background-image: url('../../../assets/endPage/login-get-btn.png');
        }
        .amap-use-btn{
          background-image: url('../../../assets/endPage/amap-use-btn.png');
        }
        .redcContentBtn{
          width: rpx(554);
          height: rpx(154);
          position: absolute;
          left: 0;
          right: 0;
          margin: auto;
          bottom: rpx(25);
          background-position: center;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          font-size: rpx(41);
          color: #c83c0e;
          font-weight: bold;
          padding-top:rpx(68) ;
          box-sizing: border-box;
          animation: breath 1.5s ease-in-out infinite;
        }
      }
    }
    .infoBox{
      width: rpx(750);
      height: rpx(430);
      padding-top: rpx(80);
      box-sizing: border-box;
      background-position: center top;
      background-size: 100% 100%;
    }
    .rule{
      width: rpx(750);
      position: relative;
      margin-top: rpx(20);
      margin-bottom: rpx(20);
    }
    .normalBtn{
      position: absolute;
      top: rpx(834);
      width: 100%;
      height: rpx(186);
    }
  }
    @keyframes breath {
    0% {
      transform: scale(0.95);
    }
    50% {
      transform: scale(1.0);
    }

    100% {
      transform: scale(0.95);
    }
  }
}

</style>
